import { UseBoundStore } from 'zustand';

/**
 * Reset store to initial state
 * - Store must have been created without the ignoreReset option
 *
 * @param {UseBoundStore<any>} store - Store to reset
 */
export const resetStore = (store: UseBoundStore<any>): void => {
  if (store.reset) {
    store.reset();
  }
};
